/**
 * Тип позиции номенклатуры: коды CommodityTypeEnum протокола ОФД 2.0.4.
 * null — не задано: касса печатает свой дефолт «Товар».
 */
export const COMMODITY_TYPES = [
    {id: 0, name: 'Товар'},
    {id: 1, name: 'Работа'},
    {id: 2, name: 'Услуга'},
];

export const commodityTypeName = (id?: number | null): string =>
    id === null || id === undefined ? '' : (COMMODITY_TYPES.find(t => t.id === Number(id))?.name ?? '');
